<template>
  <div>
    <transition-group
      appear
      :class="$style.graph"
      :enterActiveClass="$style.enterActiveGraph"
      :enterClass="$style.enterGraph"
      tag="ul"
    >
      <li
        v-for="category in categories"
        :key="category.name"
        :class="$style[category.style]"
        :style="{ 'width': `${percentage(category.qty)}%`}"
        @mouseleave="handleMouseLeaveGraph"
        @mouseover="handleMouseOverGraph($event, category)"
      />
    </transition-group>
    <transition
      :enterActiveClass="$style.enterActiveHover"
      :enterClass="$style.enterHover"
      :leaveActiveClass="$style.leaveActiveHover"
      :leaveToClass="$style.leaveToHover"
    >
      <HoverTooltip
        v-if="hoverBoxVisible"
        :class="$style.tooltip"
        :style="hoverPosition"
        @mouseLeaveHoverBox="handleMouseLeaveHoverBox"
        @mouseOverHoverBox="handleMouseOverHoverBox"
      >
        <div :class="$style.hoverTooltipContent">
          <p>
            {{ `${item.charAt(0).toUpperCase() + item.slice(1)} ${categorySelected.name}` }}
          </p>
          <p :class="$style.totalSection">
            Total {{ item }}: <span :class="$style.categoryQty">{{ categorySelected.qty }}</span>
          </p>
        </div>
      </HoverTooltip>
    </transition>
  </div>
</template>

<script>
import HoverTooltip from 'client/components/Tooltip/HoverTooltip';

export default {
  name: 'SummaryGraphContent',

  components: { HoverTooltip },

  props: {
    categories: {
      type: Array,
      required: true,
    },
    item: {
      type: String,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      categorySelected: {},
      hoverBoxVisible: false,
      mouseX: 0,
      mouseY: 0,
      graphTimeoutId: null,
      hoverBoxTimeoutId: null,
    };
  },

  computed: {
    hoverPosition() {
      return {
        top: `${this.mouseY}px`,
        left: `${this.mouseX}px`,
      };
    },
  },

  methods: {
    cancelHoverBoxTimeout() {
      window.clearTimeout(this.hoverBoxTimeoutId);
    },

    handleMouseLeaveGraph() {
      this.hoverBoxTimeoutId = window.setTimeout(this.hideHoverBox, 100);
      window.clearTimeout(this.graphTimeoutId);
    },

    handleMouseLeaveHoverBox() {
      this.hoverBoxTimeoutId = window.setTimeout(this.hideHoverBox, 350);
    },

    handleMouseOverGraph(event, categorySelected) {
      this.categorySelected = categorySelected;
      const { pageX, pageY } = event;

      this.mouseX = pageX;
      this.mouseY = pageY;

      this.cancelHoverBoxTimeout();
      this.hideHoverBox();
      this.graphTimeoutId = window.setTimeout(this.showHoverBox, 150);
    },

    handleMouseOverHoverBox() {
      this.cancelHoverBoxTimeout();
    },

    hideHoverBox() {
      this.hoverBoxVisible = false;
    },

    percentage(value) {
      return (value / this.total) * 100;
    },

    showHoverBox() {
      this.hoverBoxVisible = true;
    },
  },
};
</script>

<style module>

@import "./css/SummaryGraph.css";

.categoryQty {
  font-weight: 300;
}

.hoverTooltipContent p {
  margin: 0;
}

.totalSection {
  display: flex;
  justify-content: space-between;
}
</style>
